/** Dlouha hrana vysledku. Fotka OOP na vic rozliseni neni. */
const MAX_HRANA = 1920;

/** Nad tuhle velikost se jde na druhy a POSLEDNI pruchod s nizsi kvalitou. */
const PRAH_DRUHEHO_PRUCHODU = 2.5 * 1024 * 1024;

const KVALITA_PRVNI = 0.8;
const KVALITA_DRUHA = 0.6;

function doBlobu(canvas: HTMLCanvasElement, kvalita: number): Promise<Blob | null> {
    return new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', kvalita));
}

/**
 * Zmensi obrazek pred odeslanim.
 *
 * Zmensuje se VZDY, ne az nad nejakym prahem: pravidlo na rozmer ma strop dane
 * z principu, kdezto "sniz kvalitu, kdyz je soubor velky" cilovou velikost
 * netrefi spolehlive a svadi k opakovani. Druhy pruchod s nizsi kvalitou je
 * pojistka pro panoramata, a je POSLEDNI.
 *
 * Prevod na JPEG zahodi pruhlednost. U fotek vybaveni to nevadi a je to vymena
 * za velikost.
 *
 * Kdyz cokoli selze, vraci puvodni soubor — server ma vlastni limit, takze
 * nepovedene zmenseni znamena nanejvys odmitnuti s citelnou hlaskou, ne tichou
 * ztratu.
 */
export async function zmensiObrazek(file: File): Promise<Blob> {
    let bitmap: ImageBitmap;
    try {
        bitmap = await createImageBitmap(file);
    } catch {
        return file;
    }

    const meritko = Math.min(1, MAX_HRANA / Math.max(bitmap.width, bitmap.height));
    const sirka = Math.round(bitmap.width * meritko);
    const vyska = Math.round(bitmap.height * meritko);

    const canvas = document.createElement('canvas');
    canvas.width = sirka;
    canvas.height = vyska;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        bitmap.close();
        return file;
    }
    ctx.drawImage(bitmap, 0, 0, sirka, vyska);
    bitmap.close();

    let blob = await doBlobu(canvas, KVALITA_PRVNI);
    if (blob && blob.size > PRAH_DRUHEHO_PRUCHODU) {
        blob = (await doBlobu(canvas, KVALITA_DRUHA)) ?? blob;
    }
    return blob ?? file;
}
